import { use } from 'echarts/lib/echarts';
import { install } from './surface/install';
use(install);


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts-gl/lib/chart/surface.js
// module id = 1137
// module chunks = 0